<h1 id="page-title" data-cy="spo-create-new-title">Create New SPO</h1>

<app-wizard
        (saveClick)="saveSpo()"
        (sendClick)="sendSpo()"
        (closeClick)="closeWizard()"
        (discardClick)="closeWizard()"
        [formSubmitted]="formSubmitted"
        [disableSave]="true"
        [disableSend]="true"
        [disableContinue]=""
        [linear]="true">

    <cdk-step [label]="'1. Header'" [optional]="false" [completed]="false">
        <app-step-header [stepIndex]="0"></app-step-header>
    </cdk-step>

    <cdk-step [label]="'2. Material List'" [optional]="true" [completed]="false">
        <app-step-material-list [stepIndex]="1"></app-step-material-list>
    </cdk-step>

    <cdk-step [label]="'3. Confirm & Send'" [completed]="formSubmitted">
        <app-step-confirm-send [stepIndex]="2"></app-step-confirm-send>
    </cdk-step>
</app-wizard>
